// Lot 682 — reprise du fil après un rechargement INVOLONTAIRE.
// iPhone : quand la mémoire manque, iOS tue le processus web de WKWebView et Capacitor recharge la page → avant, le fil
// repartait en haut et la publication qu'on allait aimer / commenter disparaissait. Pendant la lecture du fil, on note
// sur l'appareil (écriture minuscule, au plus toutes les 1,5 s de défilement) la publication en haut de l'écran et son
// décalage ; au démarrage suivant, si l'enregistreur de vol classe la relance comme involontaire et que la trace a
// moins de 15 min, le fil rouvre sur cette publication (pages suivantes chargées si besoin). Un F5 volontaire, une
// relance normale ou une absence longue → fil habituel, en haut. Web ET apps (le rechargement est une page web).
const KEY = "yalola.feedResume";
export const RESUME_MAX_AGE_MS = 15 * 60 * 1000;
export const RESUME_MIN_SCROLL_PX = 300; // tout en haut : rien à reprendre
export const RESUME_MAX_PAGES = 3;        // pages supplémentaires chargées au maximum pour retrouver la publication

export const postIdFromTestId = (testId) => {
  const m = /^post-(.+)$/.exec(String(testId || ""));
  return m ? m[1] : null;
};

export const saveFeedResume = ({ uid, postId, top, filter }) => {
  if (!uid || !postId) return;
  try { localStorage.setItem(KEY, JSON.stringify({ uid, postId, top: Math.round(top || 0), filter: filter || "all", at: Date.now() })); } catch { /* quota */ }
};
export const clearFeedResume = () => { try { localStorage.removeItem(KEY); } catch { /* noop */ } };

// Lecture UNIQUE (la trace est effacée) : { postId, top, filter } si la reprise s'applique, sinon null.
// Sans `uid` (session pas encore connue au premier rendu) : null SANS consommer la trace — on redemandera.
export const takeFeedResume = (uid, { unexpected, now = Date.now() }) => {
  if (!uid) return null;
  let r = null;
  try { r = JSON.parse(localStorage.getItem(KEY) || "null"); } catch { r = null; }
  clearFeedResume();
  if (!unexpected || !r || r.uid !== uid || !r.postId) return null;
  if (!(now - (r.at || 0) < RESUME_MAX_AGE_MS)) return null;
  return { postId: r.postId, top: r.top || 0, filter: r.filter || "all" };
};
